import React from "react";
import {
    AuthorisedGarages,
    BannerText,
    CarLogoContainer,
    GaragesDescription,
    GaragesStat,
    GaragesTitle,
    ViewGaragesButton,
    ViewGaragesWrapper,
    ViewGaragesClaimsWrapper,
    ViewGaragesContainer,
    ClaimIconWrapper,
    ClaimItemText,
    ClaimsSectionTitle,
    ClaimsSectionSubtitle,
    ClaimsListContainer,
    OuterWrapper,
    ClaimBannerText,
    ClaimBannerSvg,
    ClaimBannerWrapper,
    RootContainer
} from "./styles";
import { Flex } from "@acko-tech/building-blocks.ui.common";

const ViewGaragesCard = ({ children, ...props }) => {
    const {
        bannerText,
        ctaText,
        is_visible,
        actions,
        logo,
        title,
        dealershipName,
        garagesTitle,
        garagesStat,
        garagesDescription,
        claimsSectionTitle,
        claimsSectionSubtitle,
        claimDataDetailsList,
        claimBannerText,
        showClaimBanner = true

    } = props;
    const { on_click } = actions;

    const handleViewGarages = () => {
        if (on_click && on_click.length > 0) {
            on_click?.forEach((eachFunc: any) => {
                typeof eachFunc.funCall === "function" &&
                    eachFunc.funCall({
                        ...eachFunc.args
                    });
            });
        }
    };

    return is_visible ? (
        <RootContainer>
            <OuterWrapper>
                <ClaimBannerWrapper>
                    <ClaimBannerText>{claimBannerText} </ClaimBannerText>
                    <ClaimBannerSvg xmlns="http://www.w3.org/2000/svg" width="104" height="5" viewBox="0 0 104 5" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M92.0249 1.49395C96.3924 1.70191 100.323 2.1042 101.504 2.46413C104.071 3.24645 102.84 3.26655 52.6263 3.26177C25.3447 3.25913 2.59557 3.16436 2.072 3.05117C0.814021 2.77955 1.06462 2.15111 2.52018 1.92615C3.81378 1.72632 62.2783 1.21395 77.8711 1.26588C83.4079 1.28431 89.7769 1.38697 92.0249 1.49395Z" stroke="#119340" strokeWidth="2.52413" strokeLinecap="round" />
                    </ClaimBannerSvg>
                </ClaimBannerWrapper>

                <ViewGaragesContainer>
                    <ViewGaragesWrapper>
                        <GaragesTitle>{garagesTitle}</GaragesTitle>
                        <GaragesStat>{garagesStat}</GaragesStat>
                        <GaragesDescription>
                            {garagesDescription}
                        </GaragesDescription>

                        <ViewGaragesButton onClick={handleViewGarages}>
                            {ctaText}
                        </ViewGaragesButton>
                    </ViewGaragesWrapper>
                    <ViewGaragesClaimsWrapper>
                        <ClaimsSectionTitle>{claimsSectionTitle}</ClaimsSectionTitle>
                        <ClaimsSectionSubtitle>{claimsSectionSubtitle}</ClaimsSectionSubtitle>
                        <ClaimsListContainer>
                            {claimDataDetailsList.map((item: string, index: number) => (
                                <Flex key={index} alignItems="start" margin="0 0 4px 0">
                                    <ClaimIconWrapper>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="12"
                                            viewBox="0 0 12 12"
                                            fill="none"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M5.82667 1C3.16097 1 1 3.16097 1 5.82667C1 8.49236 3.16097 10.6533 5.82667 10.6533C8.49236 10.6533 10.6533 8.49236 10.6533 5.82667C10.6533 3.16097 8.49236 1 5.82667 1ZM0 5.82667C0 2.60869 2.60869 0 5.82667 0C9.04464 0 11.6533 2.60869 11.6533 5.82667C11.6533 9.04464 9.04464 11.6533 5.82667 11.6533C2.60869 11.6533 0 9.04464 0 5.82667Z"
                                                fill="#36354C"
                                            />
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M8.14607 4.26693C8.34133 4.46219 8.34133 4.77877 8.14607 4.97403L5.36306 7.75704C5.26163 7.85847 5.09717 7.85847 4.99574 7.75704L3.51273 6.27403C3.31747 6.07877 3.31747 5.76219 3.51273 5.56693C3.708 5.37166 4.02458 5.37166 4.21984 5.56693L5.1794 6.52649L7.43896 4.26693C7.63422 4.07166 7.9508 4.07166 8.14607 4.26693Z"
                                                fill="#36354C"
                                            />
                                        </svg>
                                    </ClaimIconWrapper>
                                    <ClaimItemText>{item}</ClaimItemText>
                                </Flex>))}
                        </ClaimsListContainer>
                    </ViewGaragesClaimsWrapper>

                </ViewGaragesContainer>
            </OuterWrapper>
        </RootContainer>
    ) : null;
};

export default ViewGaragesCard;
